import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-100">
      <div className="w-full px-4 md:px-6">
        {/* Main Footer Content */}
        <div className="py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center">
                <i className="ri-movie-2-fill text-2xl text-primary-400"></i>
              </div>
              <span className="font-heading text-xl font-bold text-white">
                被窝网电影
              </span>
            </Link>
            <p className="text-foreground-300 text-sm leading-relaxed mb-5">
              被窝网电影是领先的免费高清影视资源聚合平台，致力于为影迷提供海量电影、电视剧、动漫、综艺等优质内容，高清流畅不缓冲，随时随地畅享观影乐趣。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-foreground-300 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-foreground-300 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-foreground-300 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-heading text-base font-semibold text-white mb-5">快速链接</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-foreground-300 text-sm hover:text-primary-400 transition-colors">首页</Link>
              </li>
              <li>
                <Link to="/category/movie" className="text-foreground-300 text-sm hover:text-primary-400 transition-colors">电影大全</Link>
              </li>
              <li>
                <Link to="/category/tv" className="text-foreground-300 text-sm hover:text-primary-400 transition-colors">电视剧场</Link>
              </li>
              <li>
                <Link to="/about" className="text-foreground-300 text-sm hover:text-primary-400 transition-colors">关于我们</Link>
              </li>
              <li>
                <Link to="/about" className="text-foreground-300 text-sm hover:text-primary-400 transition-colors">联系我们</Link>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h3 className="font-heading text-base font-semibold text-white mb-5">影视分类</h3>
            <ul className="space-y-3">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-foreground-300 text-sm hover:text-primary-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-heading text-base font-semibold text-white mb-5">联系方式</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3 text-foreground-300 text-sm">
                <div className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-mail-line text-foreground-400"></i>
                </div>
                <span>contact@beiwomovie.com</span>
              </li>
              <li className="flex items-start gap-3 text-foreground-300 text-sm">
                <div className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-customer-service-line text-foreground-400"></i>
                </div>
                <span>在线客服：7×24小时</span>
              </li>
              <li className="flex items-start gap-3 text-foreground-300 text-sm">
                <div className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-foreground-400"></i>
                </div>
                <span>中国 · 北京</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright Bar */}
        <div className="border-t border-foreground-800 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground-400 text-xs">
            &copy; {new Date().getFullYear()} 被窝网电影 beiwomovie.com 版权所有 | 本站所有资源均来自网络，仅供学习交流
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-foreground-400 text-xs hover:text-foreground-200 transition-colors">隐私政策</a>
            <a href="#" className="text-foreground-400 text-xs hover:text-foreground-200 transition-colors">服务条款</a>
            <a href="#" className="text-foreground-400 text-xs hover:text-foreground-200 transition-colors">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}